"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyIsNotNull = void 0;
function propertyIsNotNull(key) {
    return function (x) {
        return x[key] !== null;
    };
}
exports.propertyIsNotNull = propertyIsNotNull;
//# sourceMappingURL=propertyIsNotNull.js.map